export const subscribeFloatingNotchMeasure = (
  tabBar: HTMLElement,
  onMeasure: () => void,
): (() => void) => {
  onMeasure();

  const resizeObserver = new ResizeObserver(onMeasure);
  resizeObserver.observe(tabBar);
  window.addEventListener('resize', onMeasure);
  window.addEventListener('orientationchange', onMeasure);

  return () => {
    resizeObserver.disconnect();
    window.removeEventListener('resize', onMeasure);
    window.removeEventListener('orientationchange', onMeasure);
  };
};
